import * as React from 'react';
import { Checkmark } from '@kvika/icons';
import { StyledCheckmarkContainer, StyledTerm, StyledLinkButton } from '../styles/TermStyles';
import TermModal from './TermModal';
var Term = function (_a) {
    var title = _a.title, renderDescription = _a.renderDescription, goToBottomText = _a.goToBottomText, buttonText = _a.buttonText, testId = _a.testId, onAccept = _a.onAccept, className = _a.className, onChange = _a.onChange, _b = _a.isAccepted, isAccepted = _b === void 0 ? false : _b;
    var onChangeRef = React.useRef(onChange);
    var _c = React.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    React.useEffect(function () {
        if (onChangeRef && onChangeRef.current) {
            onChangeRef.current(isOpen);
        }
    }, [isOpen, onChangeRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTerm, { "data-testid": testId, className: className },
            React.createElement(StyledLinkButton, { "data-testid": "title-".concat(testId), onClick: function () { return setIsOpen(true); } }, title),
            React.createElement(StyledCheckmarkContainer, { isAccepted: isAccepted, "data-testid": "checkmark-".concat(testId), onClick: function () { return setIsOpen(true); } },
                React.createElement(Checkmark, null))),
        isOpen && (React.createElement(TermModal, { renderDescription: renderDescription, goToBottomText: goToBottomText, buttonText: buttonText, title: title, testId: testId, onAccept: onAccept, className: className, isOpen: true, setIsOpen: setIsOpen }))));
};
export default Term;
//# sourceMappingURL=Term.js.map